import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { CONTENT_LANGS, LANG_META, localizedPath, normalizeLang } from '../lib/contentLocale';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentLanguage = normalizeLang(i18n.language);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    const nextPath = localizedPath(location.pathname, lng);
    if (nextPath !== location.pathname) {
      navigate(nextPath);
    }
  };

  return (
    <div className="language-switcher">
      {CONTENT_LANGS.map((code) => (
        <button
          key={code}
          className={`lang-btn ${currentLanguage === code ? 'active' : ''}`}
          onClick={() => changeLanguage(code)}
        >
          {LANG_META[code].label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
